import { useField } from "formik";
import { InputControl } from "formik-chakra-ui";
import React from "react";
import { DateTypeConstraints } from "src/scenes/orgAdmin/formTemplates/ContentTab/V1/formik";
import { validateDate } from "src/services/formTemplate/question";
import { BaseInputProps } from "./QuestionDynamicInputs/Question";

export interface DateProps extends BaseInputProps {
  constraints?: DateTypeConstraints;
}

export const DateInput: React.FC<DateProps> = ({
  id,
  isDisabled = false,
  constraints,
}) => {
  const [field] = useField({
    name: id,
    validate: (value: string) => validateDate(value, constraints),
  });

  return (
    <InputControl
      inputProps={{
        type: "date",
        isDisabled: isDisabled,
        min: constraints?.startDate || "1900-01-01",
        max: constraints?.endDate || "2200-12-31",
        value: field.value,
      }}
      id={id}
      name={field.name}
    />
  );
};
